'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.wrapResponse = wrapResponse;
exports.wrapStatusResponse = wrapStatusResponse;
exports.wrapCollectionResponse = wrapCollectionResponse;

var _LegacyOffsetCollectionResponse = require('./LegacyOffsetCollectionResponse');

var _LegacyOffsetCollectionResponse2 = _interopRequireDefault(_LegacyOffsetCollectionResponse);

var _OffsetCollectionResponse = require('./OffsetCollectionResponse');

var _OffsetCollectionResponse2 = _interopRequireDefault(_OffsetCollectionResponse);

var _Response = require('./Response');

var _Response2 = _interopRequireDefault(_Response);

var _StatusResponse = require('./StatusResponse');

var _StatusResponse2 = _interopRequireDefault(_StatusResponse);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function wrapResponse(client, response) {
  return new _Response2.default(client, response);
}

function wrapStatusResponse(client, response) {
  return new _StatusResponse2.default(client, response);
}

function wrapCollectionResponse(client, response) {
  if (response.data.meta == null) {
    return new _LegacyOffsetCollectionResponse2.default(client, response);
  }
  return new _OffsetCollectionResponse2.default(client, response);
}